import { render, staticRenderFns } from "./VKCart.vue?vue&type=template&id=1180d497&lang=pug&"
import script from "./VKCart.vue?vue&type=script&lang=ts&"
export * from "./VKCart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports